// Shared Utilities for the Spreadsheet Upload portion of DIY
const testPreUploadErrors = (files, acceptedFileList) => {
  const friendlyFileListString = acceptedFileList.replace(/,/g, ', ');

  /**
   * Generic exception which catches invalid file types and size errors
   * acceptedFileList and maxSize are both props which would cause this case to occur.
   * Dropzone considers invalid file types and invalid file sizes to not complete the drop behavior
   */
  if (!files || files.length === 0) {
    return {
      preUploadError: true,
      preUploadErrorTitle: 'Invalid file type.',
      preUploadErrorText: `Please select a valid file type (${friendlyFileListString}).`
    };
  }

  if (files[0].size > 50 * 1024 * 1024) {
    return {
      preUploadError: true,
      preUploadErrorTitle: 'Invalid file size.',
      preUploadErrorText: 'The file cannot exceed 50 MB.'
    };
  }

  // Filename can only have one period
  const splitLength = files[0].name.split('.').length;
  if (splitLength > 2) {
    return {
      preUploadError: true,
      preUploadErrorTitle: 'Invalid file name.',
      preUploadErrorText: 'Please ensure your file has only one "." for the extension'
    };
  }

  // Filename can only contain alphanumeric characters, spaces, - and _
  const fileNameRegex = /^[A-Za-z0-9_-]+$/;
  const fileNameWithoutSpaces = files[0].name.split('.')[0].replace(/\s/g, '');
  const testRegex = fileNameRegex.test(fileNameWithoutSpaces);
  if (!testRegex) {
    return {
      preUploadError: true,
      preUploadErrorTitle: 'Invalid file name.',
      preUploadErrorText: 'Please use only alphanumeric characters, - and _ in your file name.'
    };
  }

  // Make sure max file length is under 100 characters
  const fileNameWithoutExtension = files[0].name
    .split('.')
    .slice(0, -1)
    .join('.');

  if (fileNameWithoutExtension.length > 100) {
    return {
      preUploadError: true,
      preUploadErrorTitle: 'File name exceeds 100 characters.',
      preUploadErrorText: 'Please adjust the number of characters in your file name and upload your catalog again.'
    };
  }

  return null;
};

export default testPreUploadErrors;
